/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getAccessToken, getLocale } from "@lib/shared/cookies";
import { ServerRequest } from "@lib/shared/types";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";

export interface ZipCodeSearchResponse {
    success: boolean;
    data: ZipCodeSearch[] | null;
}

export interface ZipCodeSearch {
    zipCode: string;
    stateCode: string;
    city: string;
}

export const getZipCodeSuggestions = async ({
    req,
    zipCode,
}: {
    zipCode: string;
    req?: ServerRequest;
}): Promise<{
    data: ZipCodeSearch[];
    error: Error | null;
}> => {
    const accessToken = req ? req.accessToken : getAccessToken();

    const config: AxiosRequestConfig = {
        method: "get",
        url: req
            ? `/validation/api/v1/lookups/zipcode/search?q=${zipCode}`
            : `/api/zipCodeSearch/${zipCode}`,
        headers: {
            "X-DOMAIN-NAME": `${req ? req?.headers?.host ?? "" : ""}`,
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken as string}`,
            "X-Language": req ? req.locale ?? "en" : getLocale(),
        },
    };

    if (req) {
        const { data: zipCodeSearchResponse, error } =
            await apiHandler<ZipCodeSearchResponse>(() => HTTP.server(config));

        return {
            data: zipCodeSearchResponse?.data ?? null,
            error,
        };
    } else {
        const { data, error } = await apiHandler<ZipCodeSearchResponse>(() =>
            HTTP.client(config),
        );
        return {
            data: data ?? null,
            error,
        };
    }
};
